module.exports = __webpack_public_path__ + "img/flower-right.268e0441.svg";